import { renderToStaticMarkup } from 'react-dom/server';

/**
 * Converts a JSX element to a static HTML string (no React bindings).
 *
 * @param {React.ReactElement} jsx - A valid JSX element to convert.
 * @param {Object} [options]
 * @param {boolean} [options.minify=false] - Whether to minify the output HTML string.
 * @returns {string} HTML string from the JSX element.
 */
export function renderToHTMLString(jsx, options = {}) {
  const { minify = false } = options;

  let html = '';

  if (
    !jsx ||
    typeof jsx !== 'object' ||
    jsx.$$typeof?.toString() !== 'Symbol(react.element)'
  ) {
    console.log('Invalid JSX element passed to renderToHTMLString()');
    return html;
  }

  html = renderToStaticMarkup(jsx);

  if (minify) {
    html = html
      .replace(/\n/g, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/>\s+</g, '><')
      .trim();
  }

  return html;
}
